/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react';
import TotalMarkers from 'src/pages/ReportsPages/ReportsBoard/CommercialsReportsPages/TotalMarkers';
import boardReportsService from 'src/services/boardReportsService';

const TotalMarkerContainer = () => {
  const [total, setTotals] = useState([]);
  const [totalGraphics, setTotalsGraphics] = useState([]);

  const [totalCategory, setTotalCategory] = useState([]);
  const [regions, setRegions] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [gSubCategoryA, setGSubCategoryA] = useState([]);
  const [gSubCategoryB, setGSubCategoryB] = useState([]);

  const [gRegionA, setGRegionA] = useState([]);
  const [gRegionB, setGRegionB] = useState([]);

  const reloadTotalMarkers = async () => {
    const [
      total,
      totalCategory,
      regions,
      totalGraphics,
      gSubCategoryA,
      gSubCategoryB,
      gRegionA,
      gRegionB,
    ] = await Promise.all([
      boardReportsService.getTotalMarkes('1', selectedDate.getFullYear()),
      boardReportsService.getTotalMarkes('2', selectedDate.getFullYear()),
      boardReportsService.getTotalMarkes('3', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketsGraphics(
        '1',
        selectedDate.getFullYear(),
      ),
      boardReportsService.getTotalMarketsGraphics(
        '2a',
        selectedDate.getFullYear(),
      ),
      boardReportsService.getTotalMarketsGraphics(
        '2b',
        selectedDate.getFullYear(),
      ),
      boardReportsService.getTotalMarketsGraphics(
        '3a',
        selectedDate.getFullYear(),
      ),
      boardReportsService.getTotalMarketsGraphics(
        '3b',
        selectedDate.getFullYear(),
      ),
    ]);

    setTotals(total);
    setTotalCategory(totalCategory);
    setRegions(regions);
    setTotalsGraphics(totalGraphics);
    setGSubCategoryA(gSubCategoryA);
    setGSubCategoryB(gSubCategoryB);
    setGRegionA(gRegionA);
    setGRegionB(gRegionB);
  };

  const handleDateChange = (value) => {
    setSelectedDate(value);
  };

  useEffect(() => {
    reloadTotalMarkers();
  }, [selectedDate]);

  return (
    <TotalMarkers
      total={total}
      regions={regions}
      gRegionB={gRegionB}
      gRegionA={gRegionA}
      gSubCategoryA={gSubCategoryA}
      gSubCategoryB={gSubCategoryB}
      selectedDate={selectedDate}
      totalCategory={totalCategory}
      totalGraphics={totalGraphics}
      handleDateChange={handleDateChange}
    />
  );
};

export default TotalMarkerContainer;
